import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=5e02a05d&scoped=true&"
import script from "./Collapsible.vue?vue&type=script&lang=ts&"
export * from "./Collapsible.vue?vue&type=script&lang=ts&"
import style0 from "./Collapsible.vue?vue&type=style&index=0&id=5e02a05d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e02a05d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VExpandTransition,VIcon})
